import React from 'react';
import RepProfileCoachingReceivedActivities from '$pages/$rep-profile/RepProfileCoachingReceivedActivities';
import {formatDuration} from 'utils/periodAsText';

export default class RepCoachingReceived extends React.Component {
  render() {
    const {coachingReceivedFrom, RepProfilePageStore, UserStore} = this.props;
    const {
      coachingActivity,
      coachingTeamMetrics,
      didCoachingActivityFetchFail,
      isCoachingActivityFetching,
      isCoachingTeamMetricsFetching,
    } = RepProfilePageStore;
    const repBeingViewed = UserStore.users.get(this.props.repId);
    const periodText = formatDuration(this.props.headerStartDate, this.props.headerEndDate, {
      shouldPluralize: false,
    });
    return (
      <div className="tab-content">
        {didCoachingActivityFetchFail ? (
          <p>There was a problem fetching the coaching activity.</p>
        ) : (
          <RepProfileCoachingReceivedActivities
            rep={repBeingViewed}
            coachingActivity={coachingActivity}
            coachingTeamMetrics={coachingTeamMetrics}
            isCoachingActivityLoading={isCoachingActivityFetching}
            isCoachingTeamMetricsLoading={isCoachingTeamMetricsFetching}
            coachingReceivedFrom={coachingReceivedFrom}
            periodText={periodText}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            headerStartDate={this.props.headerStartDate}
            headerEndDate={this.props.headerEndDate}
            location={this.props.location}
            renderTeamAverage={false}
          />
        )}
      </div>
    );
  }
}
